import { render } from "./WisdomView.vue?vue&type=template&id=427baf9d&scoped=true"
import script from "./WisdomView.vue?vue&type=script&lang=js"
export * from "./WisdomView.vue?vue&type=script&lang=js"

import "./WisdomView.vue?vue&type=style&index=0&id=427baf9d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427baf9d"]])

export default __exports__